var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"bg-white mt-8 mx-7.5 px-20 pt-8 pb-14 rounded-xl shadow-lg"},[_c('UserEdit',{attrs:{"user":_vm.userItem},on:{"close":_vm.returnUsersList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }